import React, {useState} from 'react'
import Modal from '../Modal'
import NewModal from '../NewModal/NewModal'
import Form from '../Form/Form'
import ModalsStore from '../Pages/Modals.store'
import {observer} from 'mobx-react'
import FormInput from '../Inputs/FormInput/FormInput'
import {useForm} from 'react-hook-form'
import {generateRandomString} from '../../utils/generateRandomString'
import NewSelect from '../NewSelect'
import ApiSearchInput from './APISearchInput'
import PasswordInput from '../PasswordInput'
import {cleanPhoneMask} from "../../utils/utils";


let AssistantsModal = observer(
    () => {
        const {data, methods} = ModalsStore.Modals['AssistantsModal']
        const [status, setStatus] = useState()
        const [phone, setPhone] = useState(data.initialForm.phone)

        const selectedHandler = (roleId) => {
            switch (roleId) {
                case 9:
                    return {label: 'Лаборант/Кабинет', name: 'role', value: 9}
                case 10:
                    return {label: 'Лаборант/Машина', name: 'role', value: 10}
                case 6:
                    return {label: 'Доктор', name: 'role', value: '6'}
            }
        }

        const {handleSubmit, setValue, errors, register, watch} = useForm(
            {
                defaultValues: {
                    ...data.initialForm
                }
            })

        const phoneInputHandler = event => {
            setPhone(cleanPhoneMask(event?.target?.value))
        }

        return (
            <Modal mobile={true}>
                <NewModal
                    completed={status === 'success'}
                    completedButtonText={'Продолжить'}
                    closeHandler={_ => ModalsStore.closeModal('AssistantsModal')}
                    completedText={data.editingMode ? 'Сохранено!' : 'Сотрудник добавлен!'}
                    title={data.editingMode ? 'Редактировать сотрудника' : 'Добавить сотрудника'}
                    errors={{...errors}}
                >

                    <Form
                        submitButtonText={data.editingMode ? 'Сохранить' : 'Добавить'}
                        submitHandler={
                            handleSubmit(
                                async formData => {
                                    formData.phone === '+7(___)___-__-__' && delete formData.phone
                                    formData.email === '' && delete formData.email
                                    setStatus(await methods.submit({...formData, phone}))
                                })
                        }>

                        {!data.disabledFields?.verCenter &&
                        <ApiSearchInput
                            important
                            hideIcon
                            title='Удостоверяющий центр'
                            chooseHandler={selectedOrg => {
                                setValue('verification_id', selectedOrg)
                            }}
                            orgType='verificationCenter'
                            initialValue={watch('name')}
                            name='verification_id'
                            reff={register({required: 'Выберите удостоверяющий центр из списка'})}/>
                        }
                        {!data.disabledFields?.fio &&

                        <FormInput
                            important
                            hideIcon
                            title='ФИО'
                            name='fio'
                            reff={register({required: 'Укажите название'})}/>
                        }
                        {!data.disabledFields?.email &&
                        <FormInput
                            hideIcon
                            title='E-Mail'
                            name='email'
                            type={'email'}
                            reff={register()}/>

                        }
                        {!data.disabledFields?.phone &&
                        <FormInput
                            hideIcon
                            useNumberFormat={true}
                            name={'phone'}
                            format='+7(###)###-##-##'
                            allowEmptyFormatting={true}
                            type={'tel'}
                            mask={'_'}
                            onChange={phoneInputHandler}
                            defaultValue={data?.initialForm?.phone}
                        >
                            Номер телефона
                        </FormInput>

                        }
                        {!data.disabledFields?.role &&
                        <NewSelect
                            important
                            onChange={selected => setValue('role', selected.value)}
                            name={'role'}
                            label='Роль'
                            value={selectedHandler(watch("role"))}
                            reff={register({required: 'Выберите роль'})}
                            options={data.roleSelectOptions}
                            placeholder=''/>
                        }
                        {!data.disabledFields?.login &&
                        <>
                            <input style={{display: 'none'}} name='login' ref={register({required: false})}
                                   type='text'/>
                            <FormInput
                                hideIcon
                                disabled
                                value={watch('login')}
                                title='Логин'
                                name='login'/>
                        </>
                        }

                        {!data.disabledFields?.password &&
                        <div style={{position: 'relative'}}>
                            <PasswordInput reff={register} important={false}/>
                            <span
                                style={{
                                    cursor: 'pointer',
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center' 
                                }}
                                onClick={_ => setValue('password', generateRandomString(10))}>
                                Сгенерировать новый  пароль</span>
                        </div>
                        }
                    </Form>
                </NewModal>
            </Modal>
        )
    })
export default AssistantsModal
